import { Box, Icon, Link, Typography } from '@mui/material';
import React from 'react';
import { homeBackground } from './common/ColorCodes';
import { TbCloudLock } from "react-icons/tb";
import { CONST_ROUTE_PATH } from '../route/RouteConstants';
import { CONST_BUSINESS_MAIL, CONST_SITE_LABEL, setScopedItem, STORAGE_KEYS } from './common/Helper';
import './common/Styles.css'
import Copyright from './common/Copyright';
import { useNavigate } from 'react-router-dom';

/**
 * Page Not Found Component
 * @returns 
 */
export const PageNotFound = () => {
    const navigate = useNavigate()

    const navigateToDashboard = () => {
        setScopedItem(STORAGE_KEYS.CURRENT_ROUTE, CONST_ROUTE_PATH.DASHBOARD)
        navigate(CONST_ROUTE_PATH.DASHBOARD)
    }

    return (
        <div className='onboard-request-container'>
            <Box component="div" className='error-page-container'>
                <Box className='error-page-header full-width'>
                    <Link title='Home' href="#" className='error-home-link' onClick={(v) => navigateToDashboard()} >
                        <Typography variant="h6" color="inherit">{CONST_SITE_LABEL}</Typography>
                    </Link>

                    <a href={`mailto:${CONST_BUSINESS_MAIL}`} className='error-mail-link'>{CONST_BUSINESS_MAIL}</a>
                </Box>


                <Box className='error-content-container'>
                    <Icon className='error-content-icon'>
                        <TbCloudLock />
                    </Icon>
                    <Typography variant="h4" className='error-content-text1'>We are Sorry ...</Typography>

                    <Typography component="p" className='error-content-text2'>
                        The page you are looking for is not available.
                        For more details, please connect&nbsp;
                        <Link href={CONST_ROUTE_PATH.CONTACT_US} className='error-link2'>here</Link>
                    </Typography>
                </Box>


                <Box className='full-width'>
                    <div className='error-copyright-container'>
                        <Copyright />
                    </div>

                    {/* TODO: Social Media links */}
                    {/* <a href={`mailto:${CONST_BUSINESS_MAIL}`} style={{
                    textDecoration: 'none',
                    color: '#4b0082',
                    fontWeight: '500'
                }}>{CONST_BUSINESS_MAIL}</a> */}
                </Box>
            </Box>
        </div>
    )
}